module.exports = __webpack_public_path__ + "img/checkin_step1.72f4d143.jpg";